import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OperatingprocedureComponent } from './page/operatingprocedure/operatingprocedure.component';
import { CategoriesComponent } from './page/categories/categories.component';
import { TaskComponent } from './page/task/task.component';
import { TemplatesComponent } from './page/templates/templates.component';
import { SubtaskComponent } from './page/subtask/subtask.component';
import { HolidaysComponent } from './page/holidays/holidays.component';
import { KpisComponent } from './page/kpis/kpis.component';
import { BoardComponent } from './page/board/board.component';
import { PeriodTaskComponent } from './page/board/new-task/period-task/period-task.component';
import { FromTemplateComponent } from './page/board/new-task/from-template/from-template.component';
import { NewContingencyComponent } from './page/board/new-task/new-contingency/new-contingency.component';
import { WeeklyTaskComponent } from './page/board/new-task/weekly-task/weekly-task.component';
import { CreateContingencyComponent } from './page/board/new-task/create-contingency/create-contingency.component';
import { NewTaskComponent } from './page/board/new-task/new-task.component';
import { TeamsComponent } from './page/teams/teams.component';
import { MsalGuard } from './msal';

import { OnetimeTaskComponent } from './page/board/new-task/onetime-task/onetime-task.component';
import { MonthlyTaskComponent } from './page/board/new-task/monthly-task/monthly-task.component';
import { MyTasksComponent } from './page/my-tasks/my-tasks.component';
import { EditPeriodComponent } from './page/board/new-task/edit-period/edit-period.component';
import { EditOnetimeComponent } from './page/board/new-task/edit-onetime/edit-onetime.component';
import { UnauthorizedComponent } from './page/unauthorized/unauthorized.component';

const routes: Routes = [

	
	{ path: '', component: BoardComponent, pathMatch: 'full', data: { breadcrumb: 'Dashboard' }, canActivate: [MsalGuard] },
	{ path: 'board', component: BoardComponent, data: { breadcrumb: 'Dashboard' }, canActivate: [MsalGuard] },
	{ path: 'categories', component: CategoriesComponent, data: { breadcrumb: 'Categories' }, canActivate: [MsalGuard] },
	{ path: 'operatingprocedure', component: OperatingprocedureComponent, data: { breadcrumb: 'Operating Procedure' }, canActivate: [MsalGuard] },
	{ path: 'task', component: TaskComponent, data: { breadcrumb: 'Task' }, canActivate: [MsalGuard] },
	{ path: 'templates', component: TemplatesComponent, data: { breadcrumb: 'Templates' }, canActivate: [MsalGuard] },
	{ path: 'holidays', component: HolidaysComponent, data: { breadcrumb: 'Holidays' }, canActivate: [MsalGuard] },
	{ path: 'kpis', component: KpisComponent, data: { breadcrumb: 'KPIs' }, canActivate: [MsalGuard] },
	{ path: 'teams', component: TeamsComponent, data: { breadcrumb: 'Teams' }, canActivate: [MsalGuard] },
	{ path: 'subtask', component: SubtaskComponent, data: { breadcrumb: 'Subtask' }, canActivate: [MsalGuard] },
	{ path: 'newtask', component: NewTaskComponent, data: { breadcrumb: 'Copy/ Create Task' }, canActivate: [MsalGuard] },
	{ path: 'createperiod', component: PeriodTaskComponent, data: { breadcrumb: 'Create/ Edit Period Task' }, canActivate: [MsalGuard] },
	{ path: 'createfromtemplate', component: FromTemplateComponent, data: { breadcrumb: 'Create From Template' }, canActivate: [MsalGuard] },
	{ path: 'newcontingency', component: NewContingencyComponent, data: { breadcrumb: 'Create/ Edit Contingency Task' }, canActivate: [MsalGuard] },
	{ path: 'weeklytask', component: WeeklyTaskComponent, data: { breadcrumb: 'Create Weekly Task' }, canActivate: [MsalGuard] },
	{ path: 'createcontingency', component: CreateContingencyComponent, data: { breadcrumb: 'Create Contingency' }, canActivate: [MsalGuard] },
	{ path: 'createonetime', component: OnetimeTaskComponent, data: { breadcrumb: 'Create/ Edit One-Time Task' }, canActivate: [MsalGuard] },
	{ path: 'createmonthlytask', component: MonthlyTaskComponent, data: { breadcrumb: 'Create Monthly Task' }, canActivate: [MsalGuard] },
	{ path: 'mytasks', component: MyTasksComponent, data: { breadcrumb: 'My Task' }, canActivate: [MsalGuard] },
	{ path: 'editperiod', component: EditPeriodComponent, data: { breadcrumb: 'Edit Period Task' }, canActivate: [MsalGuard] },
	{ path: 'editonetime', component: EditOnetimeComponent, data: { breadcrumb: 'Edit One-Time Task' }, canActivate: [MsalGuard] },
	{ path: 'unauthorized', component: UnauthorizedComponent, data: { breadcrumb: '' } },
	{ path: '**', component: BoardComponent, data: { breadcrumb: 'Dashboard' }, canActivate: [MsalGuard] },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
